import React, { useState, useEffect } from 'react';
import { apiRoutes } from 'api_routes/api_routes';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import GridTemplate from 'templates/GridTemplate';
import Label from 'components/atoms/Label/Label';
import { TextField } from '@mui/material';
import axiosInstance from 'api/axios';
import { useTranslation } from 'react-i18next';

const StyledWrapper = styled.div`
  padding: 35px 0;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

const InnerWrapper = styled.div`
  :first-of-type {
    z-index: 9999;
  }
  ${({ flex }) =>
    flex &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `}
`;

const ContentWrapper = styled.div`
  align-items: center;
  justify-content: center;
`;

const StyledTextField = styled(TextField)`
  width: 200px;
  @media (max-width: 1100px) {
    width: 300px;
  }
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  .MuiInputBase-input.Mui-disabled {
    -webkit-text-fill-color: #000000;
  }
  @media (max-width: 1500px) {
    grid-gap: 10px 0px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const UserInfo = ({ cardType }) => {
  const [user, setUser] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUser = async () => {
      try {
        const response = await axiosInstance.get(
          `${apiRoutes.get_user_info}${localStorage.getItem('user')}`,
          {
            signal: controller.signal,
          },
        );
        isMounted && setUser(response.data);
      } catch (err) {
        // console.error(err);
      }
    };

    getUser();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <GridTemplate pageType={`${user?.firstname} ${user?.lastname}`}>
      <StyledWrapper>
        <InnerWrapper flex>
          <StyledGrid>
            <ContentWrapper>
              <Label>{t('geid')}</Label>
              <StyledTextField
                name="geid"
                hiddenLabel
                id="outlined-basic"
                defaultValue={localStorage.getItem('user')}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
            <ContentWrapper>
              <Label>{t('firstname')}</Label>
              <StyledTextField
                name={t('firstname')}
                hiddenLabel
                id="outlined-basic"
                value={user?.firstname}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
            <ContentWrapper>
              <Label>{t('lastname')}</Label>
              <StyledTextField
                name="lastname"
                hiddenLabel
                id="outlined-basic"
                value={user?.lastname}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
            <ContentWrapper>
              <Label>{t('birthdate')}</Label>
              <StyledTextField
                name="birthdate"
                hiddenLabel
                id="outlined-basic"
                value={new Date(user?.birthdate).toLocaleDateString('pl-PL', {
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                })}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
            <ContentWrapper>
              <Label>{t('phone')}</Label>
              <StyledTextField
                name="phone"
                hiddenLabel
                id="outlined-basic"
                value={user?.phone}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
            <ContentWrapper>
              <Label>{t('email')}</Label>
              <StyledTextField
                name="email"
                hiddenLabel
                id="outlined-basic"
                value={user?.email}
                disabled
                variant="outlined"
                size="small"
              />
            </ContentWrapper>
          </StyledGrid>
        </InnerWrapper>
      </StyledWrapper>
    </GridTemplate>
  );
};

UserInfo.propTypes = {
  cardType: PropTypes.oneOf(['users']),
};

UserInfo.defaultProps = {
  cardType: 'users',
};

export default UserInfo;
